import { render, staticRenderFns } from "./vehicleIndex.vue?vue&type=template&id=22ebfd00&scoped=true&"
import script from "./vehicleIndex.vue?vue&type=script&lang=js&"
export * from "./vehicleIndex.vue?vue&type=script&lang=js&"
import style0 from "./vehicleIndex.vue?vue&type=style&index=0&id=22ebfd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebfd00",
  null
  
)

export default component.exports